import type { PalaceId, StarId } from './domain.js';

export interface RuleCoverageHold<T extends string> {
  id: T;
  status: 'safety_hold' | 'research_pending';
  reason: string;
  registryLocator: string;
}

export interface RuleCoverageException {
  ruleId: string;
  featureId: string;
  heldId: string;
  reason: string;
}

export interface RuleCoveragePolicy {
  id: string;
  version: string;
  palaceHolds: readonly RuleCoverageHold<PalaceId>[];
  majorStarHolds: readonly RuleCoverageHold<StarId>[];
  approvedExceptions?: readonly RuleCoverageException[];
}

const REGISTRY='Rule Source Registry / SRC-ZWDS-BOOK-001 使用限制';

export const PRODUCTION_RULE_COVERAGE_POLICY_0_1_0: RuleCoveragePolicy = Object.freeze({
  id:'RULE-COVERAGE-POLICY',
  version:'0.1.0',
  palaceHolds:Object.freeze<RuleCoverageHold<PalaceId>[]>([
    {id:'children',status:'research_pending',reason:'子女宮原文大量混入子女數、性別、刑剋與古代家庭制度判語；安全拆分完成前不進 production Rule。',registryLocator:REGISTRY},
    {id:'health',status:'safety_hold',reason:'疾厄宮不得轉成疾病診斷、壽命或確定健康預測；目前不以 coverage 壓力建立健康 Rule。',registryLocator:REGISTRY},
    {id:'parents',status:'research_pending',reason:'父母宮原文大量混入刑剋、死亡、階級與家庭制度判語；安全拆分完成前不進 production Rule。',registryLocator:REGISTRY},
  ]),
  majorStarHolds:Object.freeze<RuleCoverageHold<StarId>[]>([
    {id:'lianzhen',status:'safety_hold',reason:'廉貞相關古籍段落混有犯罪、性污名、疾病、死亡與階級判語；只允許未來另行拆出中性可測試訊號。',registryLocator:REGISTRY},
    {id:'tanlang',status:'safety_hold',reason:'貪狼相關古籍段落混有性污名、道德與結果判語；安全審查前不直接轉成人格 Rule。',registryLocator:REGISTRY},
    {id:'jumen',status:'safety_hold',reason:'巨門相關古籍段落混有爭訟、疾病與負面人格標籤；安全審查前不直接轉成人格 Rule。',registryLocator:REGISTRY},
    {id:'qisha',status:'safety_hold',reason:'七殺相關古籍段落混有刑傷、死亡、階級與高風險結果判語；安全審查前不直接轉成人格 Rule。',registryLocator:REGISTRY},
    {id:'pojun',status:'safety_hold',reason:'破軍相關古籍段落混有破敗、刑傷、疾病與結果判語；安全審查前不直接轉成人格 Rule。',registryLocator:REGISTRY},
  ]),
});

export const PRODUCTION_RULE_COVERAGE_POLICY_0_2_0: RuleCoveragePolicy = Object.freeze({
  ...PRODUCTION_RULE_COVERAGE_POLICY_0_1_0,
  version:'0.2.0',
  approvedExceptions:Object.freeze([
    Object.freeze({
      ruleId:'RELATIONSHIP-SPOUSE-QISHA-OBSTRUCTION-001',
      featureId:'palace.spouse.has_star.qisha',
      heldId:'qisha',
      reason:'七殺仍維持全域 safety hold；此例外只允許卷二夫妻宮七殺條直接支持的單一關係協調 counter Rule。輸出不得保留刑剋、生離、婚姻次數、早晚婚、配偶性別、死亡或成敗判語。',
    }),
  ]),
});
